import classes from './LoadingSpinner.module.css'

const LoadingSpinner = ({white}) => {
    return <div className={classes.container}>
        <span className={`loader full ${white ? 'white' : ''}`}></span>
    </div>
}

export default LoadingSpinner